export default defineNuxtRouteMiddleware(async (to) => {
	const { locale } = useNuxtApp().$i18n;
	const oneTimeTokenState = useState("oneTimeTokenPending", () => false);
	const oneTimeToken = Array.isArray(to.query["one-time-token"])
		? to.query["one-time-token"][0]
		: to.query["one-time-token"];

	// Social login
	if (to.query.token && !to.fullPath.includes(locale.value) && to.fullPath.includes("social-login-success")) {
		return navigateTo(`/${locale.value}${to.fullPath}`);
	}

	// Social registration
	if (to.query.provider && !to.fullPath.includes(locale.value) && to.fullPath.includes("social-registration")) {
		return navigateTo(`/${locale.value}${to.fullPath}`);
	}

	// Reset password
	if (to.query.token && !to.fullPath.includes(locale.value) && to.fullPath.includes("reset-password")) {
		return navigateTo(`/${locale.value}${to.fullPath}`);
	}

	if (!oneTimeToken || typeof oneTimeToken !== "string") {
		oneTimeTokenState.value = false;
		return;
	}

	oneTimeTokenState.value = true;

	if (process.server) {
		return;
	}

	const cleanedQuery = { ...to.query };
	delete cleanedQuery["one-time-token"];

	const cleanedLocation = {
		path: to.path,
		query: cleanedQuery,
		hash: to.hash,
	};
	const router = useRouter();

	window.history.replaceState(window.history.state, "", router.resolve(cleanedLocation).href);

	try {
		await useAuth.authenticateWithOneTimeToken(oneTimeToken);
	} catch (error: unknown) {
		oneTimeTokenState.value = false;

		return abortNavigation(
			createError({
				statusCode: error?.statusCode || error?.response?.status || 401,
				statusMessage: error?.statusMessage || error?.message || "One-time token authentication failed",
				data: error?.data || error?.response?.data || error?.response?._data || {},
			})
		);
	}

	return navigateTo(cleanedLocation, { replace: true });
});
